export const APP_LIST_KEY = 'staff_service_app_list';
export const APP_ID_KEY = 'staff_service_app_id';
export const APP_INFO_KEY = 'staff_service_app_info';
export const ERR_APP_ID_CODE = 150101;
export const ERR_APP_ID_CODE_JUMP_URL = '/mng/account/wework/AppList';
export const QUERY_APP_ID = 'app_id';
export const ROBOT_ID_KEY = 'robot_id';
